export default __webpack_public_path__ + "assets/fonts/Nunito-Light-f70e6bb8.woff2";